import React, { useState, ChangeEvent, useRef } from 'react';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { useMessageDismissal } from '@/utils/hooks';
import { DismissibleMessageKey } from '@/services/message-dismissal';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import SensitiveInfoConfirmDialog from '@/components/SensitiveInfoConfirmDialog';
import { Checkbox, CheckboxProps } from '@ygtechnologies/rubus-ui';

interface SensitiveInfoCheckboxProps extends Omit<CheckboxProps, 'onChange'> {
    ownerProfileId: number;
    onChange(newValue: boolean): void;
}

const SensitiveInfoCheckbox: React.FC<SensitiveInfoCheckboxProps> = ({ ownerProfileId, onChange, ...rest }) => {
    const [showDialog, setShowDialog] = useState(false);
    const projectId = useSelector((state: IState) => state.global.activeProject!.id!);

    const [doNotShow, dismiss] = useMessageDismissal(DismissibleMessageKey.SensitiveInfo, projectId);

    const checkEventRef = useRef<ChangeEvent<HTMLInputElement>>();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.persist();
        if (doNotShow === true || !e.target.checked) {
            triggerHandler(onChange, e.target.checked);
            return;
        }

        setShowDialog(true);
        checkEventRef.current = e;
    };

    const handleAccept = (doNotShowAgain) => {
        if (!checkEventRef.current) {
            return;
        }

        if (doNotShowAgain) {
            dismiss();
        }

        triggerHandler(onChange, true);
    };

    return (
        <>
            <SensitiveInfoConfirmDialog
                profileId={ownerProfileId}
                show={showDialog}
                onClose={() => setShowDialog(false)}
                onAccept={handleAccept}
            />

            <Checkbox onChange={handleChange} {...rest} />
        </>
    );
};

export default SensitiveInfoCheckbox;
